var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#fff000",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22c-.4 0-.75-.15-1.05-.45-.3-.3-.45-.65-.45-1.05V5c0-.4.15-.75.45-1.05.3-.3.65-.45 1.05-.45h1.625v-.725c0-.217.075-.4.225-.55A.779.779 0 0 1 6.925 2c.233 0 .43.075.588.225.158.15.237.342.237.575v.7h8.5v-.725c0-.217.075-.4.225-.55A.779.779 0 0 1 17.05 2c.233 0 .43.075.587.225.159.15.238.342.238.575v.7H19.5c.4 0 .75.15 1.05.45.3.3.45.65.45 1.05v15.5c0 .4-.15.75-.45 1.05-.3.3-.65.45-1.05.45h-15Zm0-1.5h15V9.75h-15V20.5Zm0-12.25h15V5h-15v3.25Zm0 0V5v3.25Z"
  })));
};

export default SvgCalendar;